import React, { forwardRef } from "react";
import InputMask from "@mona-health/react-input-mask";
import classNames from "classnames";
import { Input as BTInput } from "reactstrap";

import styles from "./index.module.scss";

const Input = forwardRef(
  (
    {
      value,
      handleBlur,
      handleChange,
      className,
      name,
      placeholder,
      mask,
      type,
      isError,
      notEditable,
      dataCCBill,
      Icon,
      ...other
    },
    ref,
  ) => {
    const setInputRef = (element) => {
      if (ref && !ref.current) {
        ref.current = element;
      }
    };

    if (type === "textarea") {
      return (
        <BTInput
          ref={ref}
          className={classNames(
            "form-control auto text-emoji-regular",
            className,
            isError && styles.errorContainer,
          )}
          value={value}
          name={name}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          data-ccbill={dataCCBill}
          type={type}
          {...other}
        />
      );
    }

    return (
      <>
        {Icon && <Icon />}
        <InputMask
          mask={mask}
          inputRef={(element) => setInputRef(element)}
          className={classNames(
            "form-control auto text-emoji-regular",
            className,
            isError && styles.errorContainer,
            notEditable && styles.notEditable,
          )}
          value={value}
          name={name}
          type={type}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          data-ccbill={dataCCBill}
          maskChar={null}
          {...other}
        />
      </>
    );
  },
);

Input.displayName = "Input";

export default Input;
